/*
	VALIDATION FOR HEALTHY LIVING ON THE GO FORM
 */
optin = {
	init: function(){
		optin.cE();
	},
	errorCount: 0,
	canSend: false,
	cE: function cacheElements() {
		optin.optinForm = $('form#text-health-optin');
		optin.radioButtons = $('.radio-options input[type="radio"]');
		optin.phoneNumber = $('input[type="tel"]');
		optin.submitButton = $("#form-submit");
		optin.cadenceError = $('.cadence-error');
		optin.phoneError = $('.phone-error');
		optin.errors = null;
		optin.el();
	},
	el: function eventListeners() {
        //  EVENT LISTENER FOR CHECKING CHECKBOX AND REMOVING ERROR IF PRESENT
        optin.radioButtons.change(function(){
            if (optin.radioButtons.is(':checked') && optin.cadenceError.hasClass('error')){
                optin.cadenceError.removeClass('error');
                if(!optin.phoneError.hasClass('error')){
                    optin.optinForm.removeClass('show-error');
                }
            }
        });
        //	EVENT LISTENER FOR HITTING ENTER KEY ON PHONE NUMBER FORM
        $(optin.phoneNumber).on('keydown', function(e){
            if(optin.phoneError.hasClass('error')){
                optin.phoneError.removeClass('error');
                if(!optin.cadenceError.hasClass('error')){
                    optin.optinForm.removeClass('show-error');
                }
            }
            optin.onlyAllowNumbers( e );
            optin.checkAndAddSlashes( e );
        });
		optin.submitButton.on('click', function (e) {
			e.preventDefault();
			optin.errors = 0;
			if ($('.show-error')){
				optin.optinForm.removeClass('show-error');
				optin.phoneError.removeClass('error');
			}
			optin.validateRadioButtons();
			var regEx 	= /^([2-9]{1})([0-9]{2})[\-\.\ ]?([0-9]{3})[-. ]?([0-9]{4})$/,
				phoneVal	= optin.phoneNumber.val(),
				clean 		= phoneVal.replace(/\D/g,'');
			validatePhone.hideCustomPhoneError();
			// If there have already been 2 errors, let this pass (having already verified it's a good number via regex)
			if((validatePhone.errorCount >= 2 && optin.errors === 0) && (phoneVal.match(regEx)&& clean.length === 10)) {
                optin.phoneNumber.val(clean);
				optin.submitForm();
				return;
			}
			var type = 'carrier';
			var json = {type: type, phone: clean};
			$.ajax({
				type: "POST",
				url: '/api/validatephone/',
				data: json,
				dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
			}).done(function(d){
				var t = d.type;
				if(t !== "mobile" && validatePhone.errorCount < 2) {
					if(t === null){
						optin.phoneError.addClass('error');
					}
					this.phoneValid = false;
					validatePhone.showCustomPhoneError(t);
					validatePhone.errorCount++;
					optin.optinForm.addClass('show-error');
					optin.errors++;
					return false;
				} else if(!phoneVal.match(regEx) || clean.length !== 10 ){
					optin.phoneError.addClass('error');
					optin.optinForm.addClass('show-error');
					optin.errors++;
				} else {
					optin.phoneError.removeClass('error');
					optin.canSend = true;
					if (optin.errors === 0 && optin.canSend) {
                        $(optin.phoneNumber).val(clean);
                        optin.submitForm();
					}
					validatePhone.phoneValid = true;
					return true;
				}
			})
		});
	},
    // ONLY ALLOW NUMBERS IN PHONE NUMBER
    onlyAllowNumbers: function (evt) {
        // Allow: backspace, delete, tab, escape, enter
        if ( $.inArray( evt.key ,["0" ,"1" ,"2" ,"3" ,"4" ,"5" ,"6" ,"7" ,"8" ,"9" ,"Backspace" ,"Delete" ,"Escape" ,"Enter" ,"ArrowRight" ,"ArrowLeft" ,"Tab"] ) === -1 ) {
            evt.preventDefault();
        }
    } ,
    // ADD SLASHES AS USER TYPES
    checkAndAddSlashes: function (evt) {

        const keyCodes = [8 ,37 ,38 ,39 ,40] ,
            str = evt.target.value;

        if ( $.inArray( evt.keyCode ,keyCodes ) === -1 ) {
            switch (str.length) {
                case 3:
                    $( evt.target ).val( str + "-" );
                    break;
                case 7:
                    $( evt.target ).val( str + "-" );
                    break;
                default:
                    break;
            }

        }
    } ,
	validateRadioButtons: function(){
		var
			radioButtons = $(optin.radioButtons),
			selected     = false,
			i            = 0;

		while(!selected && i < radioButtons.length){
			if(radioButtons[i].checked){
				selected = true;
			}
			i++;
		}
		if (!selected){
			optin.cadenceError.addClass('error');
			optin.optinForm.addClass('show-error');
			optin.errors++;
		} else {
			optin.cadenceError.removeClass('error');
		}
	},
	addToDataLayer: function(){
		window.dataLayer.push({
			'event': 'healthLivingOnGo',
			'eventCategory': 'Form',
			'eventAction': 'Submit',
			'eventLabel': 'Healthy Living On the Go'
		})
	},
    submitForm: function(){
        const formData = $('form').serialize();
        // SUBMIT FORM
        $.ajax({
            method: 'POST',
            url: '/api/hlotg-submit/',
            data: formData,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function ($data) {
            optin.addToDataLayer();
            $('.optin').addClass('success');
            isi.checkHeight();
            // scroll to top of success section
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.main-header').offset().top
            }, 1000);

        }).fail(function ($data) {
            $('.optin').addClass('failure');
        });
    }
};
